module.exports = __webpack_public_path__ + "static/media/world-news.4cee897c.jpg";